import Brightness from '@mui/icons-material/Brightness1';
import React, { FC } from 'react';
import { colors, fontWeight, fontSize, TypographyStyledGlobal } from '../../theme';
import { ColorSwatchBox, ColorContainer } from './styled';

export interface ColorSwatchInterface {
    id: number
    label: string
    rank: number
    colors: string[]
    createdAt?: Date
    updatedAt?: Date
}

interface ColorSwatchProps {
    colorSwatch: ColorSwatchInterface
    handleSelectColorSwatch: (colorSwatch: ColorSwatchInterface) => void
}

const ColorSwatch: FC<ColorSwatchProps> = ({ colorSwatch, handleSelectColorSwatch }) => (
    <ColorSwatchBox key={`color-swatch-${colorSwatch.id}`} onClick={() => handleSelectColorSwatch(colorSwatch)}>
        <TypographyStyledGlobal
            key={`color-swatch-typo-${colorSwatch.id}`}
            color={colors.grey200}
            margin='8px 0 8px 0'
            size={fontSize.sm}
            textAlign='center'
            weight={fontWeight.regular}
        >
            { colorSwatch.label }
        </TypographyStyledGlobal>
        <ColorContainer key={`color-swatch-container-${colorSwatch.id}`}>
            {colorSwatch.colors.map((color: string, index: number) => (
                <Brightness
                    /* eslint-disable */
                    key={`color-swatch-${colorSwatch.id}-color-${index}`}
                    /* eslint-enable */
                    sx={{ color }}
                />
            ))}
        </ColorContainer>
    </ColorSwatchBox>
);

export default ColorSwatch;
